<style scoped>
.underline {
  text-decoration: underline;
}
.top-margin {
    margin-top: 30px;
  }
</style>

<template>
  <v-alert
    icon=star
    text
    elevation=0
    color="primary"
    class="top-margin"
  >
    Pro Tip: You can replace 
    <strong>reddit.<span class="underline">com</span></strong>
      with 
    <strong>reddit.<span class="underline">watch</span></strong>
      in your address bar to quickly download reddit videos.
  </v-alert>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
